/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Book_Status_ReadyInputs */

const en_book_status_ready = /** @type {(inputs: Book_Status_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready`)
};

const es_book_status_ready = /** @type {(inputs: Book_Status_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listo`)
};

const fr_book_status_ready = /** @type {(inputs: Book_Status_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prêt`)
};

const de_book_status_ready = /** @type {(inputs: Book_Status_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereit`)
};

const ja_book_status_ready = /** @type {(inputs: Book_Status_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`準備完了`)
};

const zh_book_status_ready = /** @type {(inputs: Book_Status_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`准备就绪`)
};

const ar_book_status_ready = /** @type {(inputs: Book_Status_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جاهز`)
};

const id_book_status_ready = /** @type {(inputs: Book_Status_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siap`)
};

const it_book_status_ready = /** @type {(inputs: Book_Status_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronto`)
};

const ru_book_status_ready = /** @type {(inputs: Book_Status_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Готов`)
};

const pt_book_status_ready = /** @type {(inputs: Book_Status_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronto`)
};

const ko_book_status_ready = /** @type {(inputs: Book_Status_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`준비됨`)
};

/**
* | output |
* | --- |
* | "Ready" |
*
* @param {Book_Status_ReadyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const book_status_ready = /** @type {((inputs?: Book_Status_ReadyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Book_Status_ReadyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_book_status_ready(inputs)
	if (locale === "es") return es_book_status_ready(inputs)
	if (locale === "fr") return fr_book_status_ready(inputs)
	if (locale === "de") return de_book_status_ready(inputs)
	if (locale === "ja") return ja_book_status_ready(inputs)
	if (locale === "zh") return zh_book_status_ready(inputs)
	if (locale === "ar") return ar_book_status_ready(inputs)
	if (locale === "id") return id_book_status_ready(inputs)
	if (locale === "it") return it_book_status_ready(inputs)
	if (locale === "ru") return ru_book_status_ready(inputs)
	if (locale === "pt") return pt_book_status_ready(inputs)
	return ko_book_status_ready(inputs)
});